import useSWR from 'swr';

import { fetchFromOldApi } from '~/services/Http';

import { getFullEmploymentData } from '../employment/useFullEmploymentData';

import {
  LegacyAllowanceProposal,
  LegacyBenefitProposal,
  LegacySalaryProposal,
} from './types';

export const getLegacyAllowanceHistoricalProposal = async (
  employeeId: number | string,
): Promise<LegacyAllowanceProposal[]> => {
  const { emplBasic } = await getFullEmploymentData(employeeId);
  const { fEmplId: employmentId } = emplBasic;
  return fetchFromOldApi(
    `/json/employee/${employeeId}/employment/${employmentId}/allowanceproposal?period=historical`,
  ).then((response) => response.json());
};

export const getLegacyBenefitHistoricalProposal = async (
  employeeId: number | string,
): Promise<LegacyBenefitProposal[]> => {
  const { emplBasic } = await getFullEmploymentData(employeeId);
  const { fEmplId: employmentId } = emplBasic;
  return fetchFromOldApi(
    `/json/employee/${employeeId}/employment/${employmentId}/benefitproposal?period=historical`,
  ).then((response) => response.json());
};

export const getLegacySalaryHistoricalProposal = async (
  employeeId: number | string,
): Promise<LegacySalaryProposal[]> => {
  const { emplBasic } = await getFullEmploymentData(employeeId);
  const { fEmplId: employmentId } = emplBasic;
  return fetchFromOldApi(
    `/json/employee/${employeeId}/employment/${employmentId}/salaryproposal?period=historical`,
  ).then((response) => response.json());
};

type PropsType = { employeeId: number };

export const useLegacyAllowanceHistoricalProposal = (props: PropsType) => {
  const { employeeId } = props;

  const { data, isLoading, error } = useSWR(
    ['legacyAllowanceHistoricalProposal', employeeId],
    () => getLegacyAllowanceHistoricalProposal(employeeId),
  );

  return {
    data: data || [],
    isLoading,
    error,
  };
};

export const useLegacyBenefitHistoricalProposal = (props: PropsType) => {
  const { employeeId } = props;

  const { data, isLoading, error } = useSWR(
    ['legacyBenefitHistoricalProposal', employeeId],
    () => getLegacyBenefitHistoricalProposal(employeeId),
  );

  return {
    data: data || [],
    isLoading,
    error,
  };
};

export const useLegacySalaryHistoricalProposal = (props: PropsType) => {
  const { employeeId } = props;
  const { data, isLoading, error } = useSWR(
    ['legacySalaryHistoricalProposal', employeeId],
    () => getLegacySalaryHistoricalProposal(employeeId),
  );

  return {
    data: data || [],
    isLoading,
    error,
  };
};
